<template>
  <div>
    <div class="resp-container">
    </div>
    <iframe id="dashboard-frame"
      title="Dashboard Container"
      class="resp-iframe"
      style="border:none;"
      :src="iframeSrc"
      sandbox="allow-forms allow-modals allow-scripts allow-same-origin allow-downloads"
      @load="dash_onload"
    >
      <p>Your browser is not currently supported for this app, consult Enfasys team for more information.</p>
    </iframe>
    <DxLoadPanel
      :position="loadingPosition"
      v-model:visible="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgb(244, 245, 245)"
    />
  </div>
</template>

<script>
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import RawDataService from '../services/RawDataServiceTemplate';

export default {
  props: {
  },
  components: {
    DxLoadPanel
  },
  data() {
    const baseUrl = this.$appInfo.appURL;
    return {
      localDeviceDataService: new RawDataService(`sites/local/dashboards`),
      redirUrl:'/grafana/?&kiosk',
      firstload: true,
      iframeSrc: baseUrl + '/grafana/login?token=' + this.$store.state.user.accessToken,
      baseUrl,
      loadingPosition: { of: '#dashboard-frame' },
      loadingVisible: true,
    }
  },
  computed: {
    routerUid() { return this.$route.params.uid; }
  },
  methods: {
    dash_onload() { //(event)
      if (this.firstload){ //after finished login begins dashboard load
        console.log ('redirecting to:', this.redirUrl)
        this.iframeSrc = this.baseUrl + this.redirUrl;
        this.firstload = false;
      }
      else{ //when loading dashboard hides grafana menu
        try{
          //The frame url needs to be in the same server/port to have javascript control over the frame
          let frameDoc = document.getElementById("dashboard-frame").contentDocument;
          let rootDiv = frameDoc.getElementById("reactRoot")
          let sideMenu = rootDiv.firstChild.firstChild;
          sideMenu.style.display = "none";
        }catch(err){
          console.log("error trying to hide grafana menu, maybe DevEnv?", err.message)
        }
        //search wrapper deletes left space when exploring... just appears while opening modals inside
        //let search_wrapper = frameDoc.document.getElementsByTagName("search-wrapper")[0].firstChild
        //search_wrapper.style.left = "0px";
        this.loadingVisible = false;
      }
    },
  },
  mounted () {
    if (this.$route.params && this.$route.params.uid && this.$route.params.folderOrDash){
      //set redir to params dashboard or folder
      if (this.$route.params.folderOrDash=='d'){
        this.redirUrl= this.$route.params.url;
      }
      else if (this.$route.params.folderOrDash=='f'){
        this.redirUrl= `/grafana/dashboards/f/${this.$route.params.uid}`;
      }
      else{
        this.redirUrl= '/grafana';
      }
    }else{//check for default dashboard
      this.localDeviceDataService.getByKey('main')
      .then( dash => { this.redirUrl= dash.url })
      .catch( () => { console.log('error loading default dashboard'); });
    }
  }
}
</script>

<style lang="scss">
.resp-container {
    position: relative;
    overflow: hidden;
    //padding-top: 56.25%;
}
.resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
